// Task and order priority: high | medium | low (internal_tasks.priority and
// clinical_action_items.priority, medium by default). Shown as a letter
// badge: red H, yellow M, grey L, each explained on hover.
export const PRIORITIES = ["high", "medium", "low"];
export const DEFAULT_PRIORITY = "medium";

export const PRIORITY_META = {
  high: { label: "High", glyph: "H", bg: "red.500", fg: "white", hint: "High priority — handle this first" },
  medium: { label: "Medium", glyph: "M", bg: "yellow.400", fg: "gray.800", hint: "Medium priority — handle this soon" },
  low: { label: "Low", glyph: "L", bg: "gray.400", fg: "white", hint: "Low priority — handle this when there's time" },
};

export function normalizePriority(raw) {
  return PRIORITIES.includes(raw) ? raw : DEFAULT_PRIORITY;
}

// 0 = high … 2 = low; no priority sorts as medium.
export function priorityRank(priority) {
  const i = PRIORITIES.indexOf(priority);
  return i === -1 ? PRIORITIES.indexOf(DEFAULT_PRIORITY) : i;
}
